<template>
  <div>
    <v-tour :name="name" :steps="steps" :callbacks="callbacks" :options="options">
    </v-tour>
  </div>
</template>

<script>
export default {
  name: 'DdCoachMark',
  props: {
    name: {
      Type: String,
      default: 'MyTour'
    },
    // チュートリアル表示
    startCoachMark: {
      Type: Boolean,
      default: false
    },
    // フロー定義
    steps: Array
  },
  data () {
    return {
      options: {
        labels: {
          buttonSkip: '操作ガイド終了',
          buttonPrevious: '前へ',
          buttonNext: '次へ',
          buttonStop: '閉じる'
        }
      },
      callbacks: {
        onPreviousStep: this.myCustomPreviousStepCallback,
        onNextStep: this.myCustomNextStepCallback,
        onStop: this.myCustomStopCallback
      }
    }
  },
  watch: {
    startCoachMark: function (n) {
      if (n === true) {
        const attName = this.name
        this.$tours[attName].start()
      }
    }
  },
  mounted: function () {
  },
  methods: {
    myCustomPreviousStepCallback (currentStep) {
      console.log('[Vue Tour] A custom previousStep callback has been called on step ' + (currentStep + 1))
    },
    myCustomNextStepCallback (currentStep) {
      console.log('[Vue Tour] A custom nextStep callback has been called on step ' + (currentStep + 1))

      if (currentStep === 1) {
        console.log('[Vue Tour] A custom nextStep callback has been called from step 2 to step 3')
      }
    },
    myCustomStopCallback () {
      this.$emit('reset')
    }
  }
}
</script>

<style scoped>
/*
 * node_modules/vue-tour/src/component/VTour.vue 定義のstyleを上書き
 */
::v-deep .v-step {
  max-width: 600px;
  background: #50596c; /* #ffc107, #35495e */
  color: white;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px,
    rgba(0, 0, 0, 0) 0px 0px 0px 0px,
    rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  padding: 1rem;
  pointer-events: auto;
  text-align: left;
  z-index: 10000;
}
::v-deep .v-step[data-popper-placement^="right"] > .v-step__arrow {
    left: 0px;
  }
</style>
